<template>
	<div class="pdf">
		<div class="w-100 text-center canvas-container">
			<div v-show="!loading">
				<canvas v-if="twoPage" style="max-width: 48%"></canvas>
				<canvas v-if="twoPage" style="max-width: 48%"></canvas>
				<canvas v-else style="max-width: 100%"></canvas>
			</div>
			<div v-if="loading" style="padding-top: 100px;" class="text-center">
				Loading...
			</div>
		</div>
	</div>
</template>

<style scoped>
	.canvas-container {
		width: 100%;
		height: calc(100%);
	}

	.canvas-container > div {
		max-height: 100%;
		height: 100%;
	}

	canvas {
		background: white;
		max-height: calc(100%);
		height: 100%;
	}
</style>

<script>
	import pdfjsLib from "pdfjs-dist"

	pdfjsLib.GlobalWorkerOptions.workerSrc = "//unpkg.com/pdfjs-dist@2.0.943/build/pdf.worker.js" // TODO

	export default {
		props: {
			url: {
				type: String
			},
			twoPage: {
				type: Boolean
			}
		},
		data: () => {
			return {
				page: 1,
				total: 1,
				pdf: null,
				loading: true
			}
		},
		methods: {
			setPage: function (page) {
				if (page <= this.total && page > 0) {
					this.page = page
				}
			},
			loadPage: function () {
				let scale = 2

				let leftCanvas = this.$el.querySelector("canvas:first-of-type")
				let rightCanvas = this.$el.querySelector("canvas:last-of-type")

				function renderPage (page, canvas) {
					var viewport = page.getViewport(scale)
					let context = canvas.getContext("2d")
					canvas.height = viewport.height
					canvas.width = viewport.width
					var renderContext = {
						canvasContext: context,
						viewport: viewport
					}
					page.render(renderContext)
				}

				this.pdf.getPage(this.page).then(page => {
					renderPage(page, leftCanvas)
				})

				if (this.page + 1 <= this.total) {
					this.pdf.getPage(this.page + 1).then(page => {
						renderPage(page, rightCanvas)
					})
				} else {
					rightCanvas.getContext("2d").clearRect(0, 0, rightCanvas.width, rightCanvas.height)
				}
			},
			prev: function () {
				if (this.twoPage) {
					this.setPage(this.page - 2)
				} else {
					this.setPage(this.page - 1)
				}
			},
			next: function () {
				if (this.twoPage) {
					this.setPage(this.page + 2)
				} else {
					this.setPage(this.page + 1)
				}
			},
			initialise: function () {
				let pdfFuture = pdfjsLib.getDocument(this.url)
				pdfFuture.promise.then(pdf => {
					this.total = pdf.numPages
					this.pdf = pdf
					this.loadPage()
					this.$on("PreviousPage", () => this.prev())
					this.$on("NextPage", () => this.next())
					this.loading = false
				})
			}
		},
		watch: {
			url: function () {
				if (this.url) {
					this.initialise()
				}
			},
			page: function () {
				this.loadPage()
			}
		},
		mounted: function () {
			if (this.url) {
				this.initialise()
			}
		}
	}
</script>
